var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42426 2.57183C8.18995 2.33751 7.81005 2.33751 7.57574 2.57183L3.75736 6.39021C3.52304 6.62452 3.52304 7.00442 3.75736 7.23873C3.99167 7.47305 4.37157 7.47305 4.60589 7.23873L8 3.84462L11.3941 7.23873C11.6284 7.47305 12.0083 7.47305 12.2426 7.23873C12.477 7.00442 12.477 6.62452 12.2426 6.39021L8.42426 2.57183ZM8.6 14.9961L8.6 2.99609L7.4 2.99609L7.4 14.9961L8.6 14.9961Z",
    fill: "#08A781"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGreen);
export default __webpack_public_path__ + "static/media/arrow-green.046bf6bea2ea308ef5bb28b42e9f059a.svg";
export { ForwardRef as ReactComponent };